import { useNavigate } from "react-router";
import { Title } from "../../routes/main-styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft } from "@fortawesome/pro-light-svg-icons";

function BackButton() {
  const navigate = useNavigate();
  function goBack() {
    window.scrollTo(0, 0);
    navigate(-1);
  }
  return (
    <Title
      onClick={goBack}
      style={{
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        gap: "5px",
      }}
    >
      <FontAwesomeIcon icon={faAngleLeft} />
      Voltar
    </Title>
  );
}

export default BackButton;
